import { render, staticRenderFns } from "./orderDetails.vue?vue&type=template&id=de1c6fe8&scoped=true"
import script from "./orderDetails.vue?vue&type=script&lang=js"
export * from "./orderDetails.vue?vue&type=script&lang=js"
import style0 from "./orderDetails.vue?vue&type=style&index=0&id=de1c6fe8&prod&lang=less&scoped=true"
import style1 from "./orderDetails.vue?vue&type=style&index=1&id=de1c6fe8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de1c6fe8",
  null
  
)

export default component.exports